import Paper from 'components/paper';
import SiteContactEmails from './components/site-contact-emails';
import SiteContactNumbers from './components/site-contact-numbers';
import { Grid } from '@mui/material';

type Props = {};

const ContactDetails: React.FC<Props> = ({}) => {
  return (
    <>
      <Paper transparent>
        <Grid container spacing={8}>
          <Grid size={{ xs: 12, md: 6 }}>
            <SiteContactEmails />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <SiteContactNumbers />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default ContactDetails;
